(function () {
  if (window.__ETOILE_STORY_STAR__) {
    window.__ETOILE_STORY_STAR__();
    return;
  }
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var observer = null;
  if (window.IntersectionObserver && motion && !motion.matches) {
    observer = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.setAttribute('data-star-played', '');
        observer.unobserve(entries[i].target);
      }
    }, { threshold: 0.5 });
  }
  function init() {
    if (!observer) return;
    var elements = document.querySelectorAll('[data-etoile-story-star]');
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute('data-star-observed')) continue;
      elements[i].setAttribute('data-star-observed', '');
      observer.observe(elements[i]);
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target;
    while (button && button !== document) {
      if (button.getAttribute && button.hasAttribute('data-etoile-star-greeting')) break;
      button = button.parentNode;
    }
    if (!button || button === document || !motion || motion.matches ||
        button.classList.contains('is-greeting')) return;
    button.classList.add('is-greeting');
    window.setTimeout(function () {
      button.classList.remove('is-greeting');
    }, 1300);
  });
  window.__ETOILE_STORY_STAR__ = init;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
